//GeneratorFlag:[NoChange]
import Process from './process';
import ProcessGroup from './process-group';

export default {Process, ProcessGroup}
export{Process, ProcessGroup}